import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { SignuuService } from './signuu.service';
import { FileUploadModule } from 'ng2-file-upload';

import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    FormsModule, BrowserModule, HttpClientModule, FileUploadModule
  ],
  providers: [SignuuService],
  bootstrap: [AppComponent]
})
export class AppModule { }
